import { render } from "./BenefitHowToModal.vue?vue&type=template&id=0b8172b4&scoped=true"
import script from "./BenefitHowToModal.vue?vue&type=script&lang=js"
export * from "./BenefitHowToModal.vue?vue&type=script&lang=js"

import "./BenefitHowToModal.vue?vue&type=style&index=0&id=0b8172b4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b8172b4"]])

export default __exports__